<template>
  <!-- -->
  <div class="" style="height: 100%;">
    <list-page>
      <list-table background-color="#FFF" class="list-table" :show-shadow="false">
        <form-items :columns="2" :data="dataDetail" ref="dataForm">
          <form-item label="项目名称" :required="true" name="projectName" error-message="请输入项目名称">
            <el-input v-model="dataDetail.projectName" placeholder="请输入项目名称"/>
          </form-item>
          <form-item label="负责人" :required="true" name="leader" error-message="请选择负责人">
            <employee-select v-model="dataDetail.leader"/>
          </form-item>
          <form-item label="默认考勤" :required="true" error-message="请选择默认的考勤规则" name="attendConfigId">
            <el-select v-model="dataDetail.attendConfigId">
              <el-option v-for="item in configList" :key="item.id" :value="item.id" :label="item.configName"/>
            </el-select>
          </form-item>
          <form-item label="所属部门" :required="true" name="departCode" error-message="请选择所属部门">
            <depart-select v-model="dataDetail.departCode" :data="departTree" placeholder="请选择所属部门"/>
          </form-item>
          <form-item label="项目类别">
            <el-input v-model="dataDetail.projectType" placeholder="请输入项目类别"/>
          </form-item>
          <form-item label="重要等级">
            <el-input v-model="dataDetail.level" placeholder="请输入重要等级"/>
          </form-item>
          <form-item label="合同编号">
            <el-input v-model="dataDetail.contractNo" placeholder="请输入合同编号"/>
          </form-item>
          <form-item label="合同金额">
            <el-input v-model="dataDetail.contractAmount" placeholder="请输入合同金额"/>
          </form-item>
          <form-item label="项目流程">
            <el-select v-model="dataDetail.status" placeholder="请选择项目流程状态">
              <el-option label="未开始" :value="0"/>
              <el-option label="进行中" :value="1"/>
              <el-option label="完成" :value="100"/>
            </el-select>
          </form-item>
          <form-item label="计划时间">
            <date-range v-model:start-time="dataDetail.planStartTime" v-model:end-time="dataDetail.planEndTime" :show-short-cut="false"/>
          </form-item>
          <form-item label="实际时间">
            <date-range v-model:start-time="dataDetail.actualStartTime" v-model:end-time="dataDetail.actualEndTime" :show-short-cut="false"/>
          </form-item>
        </form-items>
      </list-table>
      <form-page :show-page="false">
        <page-button type="write" el-type="primary" @click="save">保存</page-button>
      </form-page>
    </list-page>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import FormItem from "@/components/h5/layout/FormItem.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import DateRange from "@/components/h5/date/YqDateRange.vue";
import {watch} from "vue";
import projectApi from "@/api/dz-luqiao/luqiaoProjectApi";
import commonApi from "@/api/commonApi";
import DynamicData from "@/components/h5/data/DynamicData.vue";
import DepartSelect from "@/components/h5/data/DepartSelect.vue";

export default {
  props: {
    modelValue: {default: () => {}}
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "ProjectInfo",
  components: {
    DepartSelect,
    FormItems, FormPage, PageButton, ListTable, ListPage, FormItem, EmployeeSelect, DateRange, DynamicData
  },
  data() {
    return {
      dataDetail: {},
      departTree: [],
      configList: []
    };
  },
  created() {
    this.initData();
    watch(() => this.data, () => {this.initData()})
  },
  methods: {
    async initData() {
      this.dataDetail = this.modelValue || {};
      // 查询部门数据
      this.departTree = await commonApi.queryDepartList();
      this.configList = await projectApi.queryAllAttendConfig();
    },
    async save(){
      if (!this.$refs.dataForm.validCheck()) {
        return;
      }
      let data = await projectApi.saveSubmit(this.dataDetail);
      this.$emit("update:modelValue", data);
    }
  }
};
</script>

<style lang="scss" scoped>
.list-table{
  display: flex;
  flex-direction: column;
  .map{
    flex: 1;
    height: 100px;
  }
}

</style>